import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import useFetch from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

export const useCreateBooking = () => {
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: any) => {
      const response = fetch<{ paymentLink: string; bookingId: number }>(`${Urls.Booking}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
        }),
      });

      return response;
    },
    onError: (error) => {
      toast.error(error.message || "Error creating booking");
    },
  });
};
